module.exports = __webpack_public_path__ + "static/Coinfirm-8407d25410c089a10541dc733b6be091.png";